module.exports = __webpack_public_path__ + "static/img/2_8_1.ae462ff7.jpg";